@if (code(); as code) {
  <img
    class="tw:block"
    [src]="'assets/icons/flags/' + code + '.svg'"
    [alt]="label()"
    [width]="width()"
    [height]="height()"
  />
}
